export default __webpack_public_path__ + "static/three-point-press-diagram-85e6f491b6598c2a266565578bdf73c2.jpg";